import { useCarousel } from 'nuka-carousel';
import isNewConsumerApp from 'commons/isNewConsumerApp';

const useCarouselFix = isNewConsumerApp ? useCarousel : () => {};

export default useCarouselFix;
